import useImage from 'entities/hooks/useImage';
import React, { Image, Flex } from 'rebass';

function TemplateRenderer({
  example,
  onTemplateSelection,
  isFromPreview = false,
  isSubmitting,
  isSelected,
}) {
  const src = useImage({ id: example?.id, size: 2 });
  return (<Flex sx={{
    background: '#FAFAFA',
    boxShadow: '0 0.967px 1.933px 0.483px rgba(0, 0, 0, 0.15)',
    border: isSelected
      ? '2px solid #9B59B6'
      : '',
    // p: 2,
    // borderRadius: '4.86px',
    cursor: 'pointer',
  }}
    mb={1}
  >
    <Image
      src={src}
      disabled={isSubmitting}
      sx={{

        // borderRadius: '4.86px',
      }}
      onClick={onTemplateSelection}
      loading="lazy"
      decoding="async"
    />
  </Flex>
  );
}

export default TemplateRenderer;
